import UploadRegimeProofError from './UploadRegimeProofError';
class InvestorCouldNotUploadRegimeProof extends UploadRegimeProofError {
    constructor(options) {
        super('Investor has invalid status to upload fiscal regime proof', options);
    }
}
export default InvestorCouldNotUploadRegimeProof;
